// extracted by mini-css-extract-plugin
module.exports = {"listItem":"ProductSpecialOffersAccordion_listItem__bca5B","productSpecialOffersList":"ProductSpecialOffersAccordion_productSpecialOffersList__s9SzZ"};